import React, { useState } from "react";
import styles from "./Tooltip.module.sass";
const Tooltip = ({
  key,
  value,
  children,
  timeoutDuration = 500
}) => {
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const [isTooltipHovered, setTooltipHovered] = useState(false);
  let timeoutId;
  const handleMouseEnter = () => {
    clearTimeout(timeoutId);
    setTooltipVisible(true);
  };
  const handleMouseLeave = () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      setTooltipVisible(false);
    }, timeoutDuration);
  };
  const handleTooltipMouseEnter = () => {
    setTooltipHovered(true);
  };
  const handleTooltipMouseLeave = () => {
    setTooltipHovered(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    key: key,
    className: ` ${styles["tooltip-container"]}`,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, children, (isTooltipVisible || isTooltipHovered) && /*#__PURE__*/React.createElement("span", {
    className: `
                        ${styles["tooltip"]}
                    `,
    onMouseEnter: handleTooltipMouseEnter,
    onMouseLeave: handleTooltipMouseLeave
  }, value.toLocaleString()));
};
export default Tooltip;